export default __webpack_public_path__ + "static/media/error-2.e2144c6a.png";